import React, { useState } from 'react';
import { WineNav } from './WineNav';
import { WineStory } from './WineStory';
import { WineScale } from './WineScale';
import { WineFlights } from './WineFlights';
import { WineList } from './WineList';
import { WineBooking } from './WineBooking';
import type { WineFlight } from '../../data/wine';
export function WineExperience() {
  const [selectedFlight, setSelectedFlight] = useState<WineFlight['id'] | null>(null);
  const [addonSelected, setAddonSelected] = useState(false);
  const handleSelectFlight = (id: WineFlight['id']) => {
    setSelectedFlight(id);
    document.getElementById('boka-bord')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  const handleToggleAddon = () => setAddonSelected(prev => !prev);
  return <>
      <WineNav data-id="element-190" data-mp="3r9dj14owaja8" />
      <WineStory data-id="element-191" data-mp="3r8u3tvqmq8zw" />
      <WineScale data-id="element-192" data-mp="3raex7i17jlw6" />
      <WineFlights selectedFlight={selectedFlight} addonSelected={addonSelected} onSelectFlight={handleSelectFlight} onToggleAddon={handleToggleAddon} data-id="element-193" data-mp="3r9vp0t1d0bvc" />
      <WineList data-id="element-194" data-mp="3r3m968plkzfi" />
      <WineBooking selectedFlight={selectedFlight} addonSelected={addonSelected} onSelectFlight={setSelectedFlight} onToggleAddon={handleToggleAddon} data-id="element-195" data-mp="3r79yevo0ezof" />
    </>;
}